import router from '@/router'
import { Dialog } from 'vant'
import webLog from './webLog'
import store from '@/store'
import { isMiniProgramNew } from '@/globalFun'

/**
 * 跳转页面方法封装
 * @param routeUrl 路由页面路径
 */
export const mixinGoPage = (routeUrl) => {
  let url
  if (/^http/.test(routeUrl)) {
    url = routeUrl
  } else {
    url = location.href.replace(/#\/.+$/, `#${routeUrl}`)
  }
  if (hcApp.isHCApp()) {
    // 调用webview多开方法
    hcApp.postMessage({
      methodName: 'openNewWebview',
      params: { url },
    })
  } else if (isMiniProgramNew()) {
    wx.miniProgram.navigateTo({ url: `/pages/webview/store?url=${encodeURIComponent(url)}` })
  } else {
    if (/^http/.test(routeUrl)) {
      location.href = routeUrl
    } else {
      router.push(routeUrl)
    }
  }
}

/**
 * 页面返回方法封装
 * @param step 回退层级，-1代表回退上一层
 */
export const mixinGoBack = (step) => {
  if (hcApp.isHCApp()) {
    // 调用webview返回方法
    hcApp.postMessage({
      methodName: 'goBack',
    })
  } else if (isMiniProgramNew()) {
    // bugfix: ios下必须要加延时才能返回
    if (isIOS()) {
      setTimeout(() => {
        wx.miniProgram.navigateBack({ delta: 1 })
      }, 1000)
    } else {
      wx.miniProgram.navigateBack({ delta: 1 })
    }
  } else {
    router.go(step || -1)
  }
}

/**
 * 阿里云日志上报
 * @param {object} params
 */
export const sendLog = (params) => {
  webLog.sendImmediate({
    sysName: 'webapp',
    url: location.href,
    userAgent: navigator.userAgent,
    token: store.state?.userInfo?.acpToken,
    ...params,
  })
}

/**
 * 执行animate动画，活动结束删除对应类名
 * @param {string} element css选择器字符串
 * @param {string} animation 动画名称
 */
export const animateCSS = ({ element, animation, duration = '1s', hideOnFinish, prefix = 'animate__' }) =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`
    const node = document.querySelector(element)

    if (node.style.display === 'none') {
      node.style.display = 'block'
    }
    node.style.setProperty('--animate-duration', duration)
    node.classList.add(`${prefix}animated`, animationName)

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation()
      node.classList.remove(`${prefix}animated`, animationName)
      if (hideOnFinish) {
        node.style.display = 'none'
      }
      resolve('Animation ended')
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true })
  })

/**
 * 动态加载js
 * @param {string} url js地址
 * @returns {Promise}
 */
export const loadScript = (url) => {
  return new Promise((resolve) => {
    const head = document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    // 借鉴了jQuery的script跨域方法
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
        resolve()
        // Handle memory leak in IE
        script.onload = script.onreadystatechange = null
        if (head && script.parentNode) {
          head.removeChild(script)
        }
      }
    }
    // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
    head.insertBefore(script, head.firstChild)
  })
}

/**
 * 动态加载css
 * @param {string} url css地址
 * @returns {Promise}
 */
export const loadCss = (url) => {
  return new Promise((resolve) => {
    const fileref = document.createElement('link')
    fileref.setAttribute('rel', 'stylesheet')
    fileref.setAttribute('type', 'text/css')
    fileref.setAttribute('href', url)
    fileref.onload = resolve
    document.getElementsByTagName('head')[0].appendChild(fileref)
  })
}

/**
 * 判断是否微信环境
 * @returns boolean
 */
export const isWeChat = () => {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * 判断是否QQ环境
 * @returns boolean
 */
export const isQQ = () => {
  const ua = window.navigator.userAgent
  if (/QQ\/\d/i.test(ua)) {
    return true
  }
  return false
}

/**
 * 判断是否是小程序
 * @returns Promise
 */
export const isMiniProgram = () => {
  return new Promise((resolve) => {
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    } else {
      resolve(false)
    }
  })
}

export const checkOuterEnv = () => {
  if (hcApp.isHCApp() || isMiniProgramNew()) {
    return false
  }
  Dialog.confirm({
    message: '是否前往恒驰App查看？',
    beforeClose: (action) =>
      new Promise((resolve) => {
        if (action === 'confirm') {
          setTimeout(() => {
            resolve(true)
          }, 6000)
        } else {
          resolve(true)
        }
      }),
  })
  setTimeout(() => {
    const data = {
      el: '.van-dialog__confirm',
      path: '/webview',
      default: '',
      params: { url: encodeURIComponent(location.href) },
    }
    window.MobLink(data)
  }, 100)
  return true
}

export const isFangCheBaoApp = () => {
  const query = {}
  const queryStr = location.href.split('?')[1] || ''
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    query[key] = value
  })
  if (query.source === 'fangchebao') {
    localStorage.setItem('fangchebao_flag', 1)
  }
  return query.source === 'fangchebao' || localStorage.getItem('fangchebao_flag')
}

export const isIOS = () => {
  return navigator.userAgent.toLowerCase().indexOf('iphone') > -1
}

export const isAndroid = () => {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.indexOf('adr') > -1
}

/**
 * 上报事件，添加浏览时长参数
 */
export const collectEventAddDuration = async (eventName, params) => {
  // App 1.0.8以后的版本新增了返回钩子函数, ios侧滑不触发回调，所以仅安卓生效
  if (hcApp.isHCAndroidApp() && hcApp.isGreaterThan('1.0.8')) {
    const viewStartTime = new Date().getTime()
    await hcApp.postMessage({
      methodName: 'registerBackHook',
    })
    const viewEndTime = new Date().getTime()
    params.event_duration = Number(((viewEndTime - viewStartTime) / 1000).toFixed())
    console.log('浏览时长：', params)
    window.collectEvent(eventName, params)
    setTimeout(() => {
      hcApp.postMessage({ methodName: 'goBack', immediate: true })
    }, 200)
  } else {
    console.log('不支持返回钩子函数，立即发送统计事件')
    window.collectEvent(eventName, params)
  }
}
/**
 *
 * @param {需要压缩的图片链接或者base64字符串，图片需支持跨域} imgUrlOrBase64
 * @param {压缩比} rate
 */
export function compressImg(imgUrlOrBase64, isIntelligent = true, rate = 0.92) {
  // 精确计算base64文件大小,并动态计算压缩比
  if (isIntelligent) {
    rate = caculateRate(imgUrlOrBase64.length - imgUrlOrBase64.length / 4)
  }
  return new Promise((resolve, reject) => {
    const img = new Image()
    if (!imgUrlOrBase64) {
      reject(new Error('图片url必传'))
    }

    img.crossOrigin = 'anonymous'
    img.src = imgUrlOrBase64
    img.onload = function () {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = this.naturalWidth
      canvas.height = this.naturalHeight
      context.drawImage(img, 0, 0)
      const newUrl = canvas.toDataURL('image/jpeg', rate)
      resolve(newUrl)
    }
  })
}

/**
 *
 * @param {需要压缩的图片file} file
 * @param {是否开启智能压缩} isIntelligent
 * @param {压缩比} rate
 */
export function compressFile(file, isIntelligent = true, rate = 0.92) {
  return new Promise((resolve, reject) => {
    if (isIntelligent) {
      rate = caculateRate(file.size)
    }
    const reader = new FileReader()
    if (file) {
      reader.readAsDataURL(file)
    } else {
      reject(new Error('文件必传'))
    }
    reader.onload = async (e) => {
      const result = await compressImg(e.target.result, rate)
      resolve(result)
    }
  })
}

/**
 * 根据文件大小动态计算压缩比
 * @param {文件大小} size
 * @returns 压缩比
 */
function caculateRate(size) {
  let rate
  if (size < 1000000) {
    rate = 0.8
  } else if (size < 2000000) {
    rate = 0.7
  } else if (size < 3000000) {
    rate = 0.6
  } else if (size < 5000000) {
    rate = 0.5
  } else {
    rate = 0.4
  }
  console.log('rate', rate)
  return rate
}

/**
 * base64转成blob
 * @param {base64图片流} base64
 * @returns
 */
export function base64ToBlob(base64) {
  const parts = base64.split(';base64,')
  const contentType = parts[0].split(':')[1]
  const raw = window.atob(parts[1])
  const rawLength = raw.length

  const uInt8Array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; i += 1) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], { type: contentType })
}
